import { resolve } from 'acast-www-utils';
import MemoryAdapter from './adapters/memory';
import LocalStorageAdapter from './adapters/local-storage';

const SessionKey = {
  TOKEN: 'acast-www-session/token',
  EXPIRES: 'acast-www-session/expires',
  USER_ID: 'acast-www-session/userId',
  DEVICE_ID: 'acast-www-session/deviceId',
};

let CurrentInstance = null;

export default class Cookie {
  static get Current() {
    return CurrentInstance;
  }

  static create(options) {
    if (CurrentInstance === null) {
      CurrentInstance = new Cookie(options);
    }
    return CurrentInstance;
  }

  constructor(options = {}) {
    let adapter = false;

    if (typeof options.adapter === 'string') {
      switch (options.adapter) {
        case 'memory':
          adapter = new MemoryAdapter();
          break;

        case 'localstorage':
          adapter = new LocalStorageAdapter();
          break;

        default:
          adapter = false;
          break;
      }
    }

    this.adapter = adapter || new MemoryAdapter();
  }

  get token() {
    return {
      token: this.adapter.get(SessionKey.TOKEN),
      expires: this.adapter.get(SessionKey.EXPIRES),
      userId: this.adapter.get(SessionKey.USER_ID),
      deviceId: this.adapter.get(SessionKey.DEVICE_ID),
    };
  }

  set token(obj = {}) {
    this.adapter.set(SessionKey.TOKEN, obj.token);
    this.adapter.set(SessionKey.EXPIRES, obj.expires);
    this.adapter.set(SessionKey.USER_ID, obj.userId);
    this.adapter.set(SessionKey.DEVICE_ID, obj.deviceId);
    return this;
  }

  get isTokenValid() {
    const token = this.token || {};
    const expires = parseFloat(token.expires);

    return (
      typeof token.token === 'string' &&
      token.token.length > 0 &&
      typeof token.userId === 'string' &&
      token.userId.length > 0 &&
      !isNaN(expires) &&
      expires > Date.now()
    );
  }

  get bearer() {
    return resolve(this.token, 'token', null);
  }

  get userId() {
    return resolve(this.token, 'userId', null);
  }

  get deviceId() {
    return resolve(this.token, 'deviceId', null);
  }

  get expires() {
    const time = parseFloat(resolve(this.token, 'expires', NaN));
    if (isNaN(time)) {
      return new Date(Date.now() - 1000);
    }
    return new Date(time);
  }
}
